import angular from 'angular';
import {
    EntityTypeToRole,
    RoleToEntityType,
    SignerRoleDropdownOptions,
    EntityAndRoleMap
} from './entity-types';
import { EsignaturesMergeFieldStatusEnum } from './esignatures-merge-fields-constants';
import {
    Direction,
    SignerRoles,
    HelloSignClientEvent,
    DocumentSignerStatus,
    DocumentSignerStatusKeys,
    ReminderSentDisplayName,
    DocumentStatus,
    DocumentStatusKeys,
    TemplateFileLimit,
    EsignatureRequestFileLimit,
    MergeFields,
    MergeFieldSource,
    ButtonStatus,
    SessionTimes,
    MergeFieldTypes,
    DocumentTypes,
    DocumentTypesFilters
} from './esignatures';

export const HelloSignClientConstantsModule = angular.module('buildium.manager.leases.esignatures.constants.helloSign', [])
    .constant('HELLOSIGN_CLIENT_EVENT', HelloSignClientEvent);

export const HelloSignSessionTimesConstantsModule = angular.module('buildium.manager.leases.esignatures.constants.helloSignSessionTimes', [])
    .constant('HELLOSIGN_SESSION_TIMES', SessionTimes);

export const EsignaturesStatusConstantsModule = angular.module('buildium.manager.leases.esignatures.constants.status', [])
    .constant('DOCUMENT_SIGNER_STATUS', DocumentSignerStatus)
    .constant('DOCUMENT_SIGNER_STATUS_KEYS', DocumentSignerStatusKeys)
    .constant('REMINDER_SENT_DISPLAY_NAME', ReminderSentDisplayName)
    .constant('DOCUMENT_STATUS', DocumentStatus)
    .constant('DOCUMENT_STATUS_KEYS', DocumentStatusKeys)
    .constant('BUTTON_STATUS', ButtonStatus)
    .constant('DOCUMENT_TYPES_FILTERS', DocumentTypesFilters)
    .constant('DOCUMENT_TYPES', DocumentTypes);

export const EsignaturesSignerRolesConstantsModule = angular.module('buildium.manager.leases.esignatures.constants.signerRoles', [])
    .constant('SIGNER_ROLES', SignerRoles);

export const EsignaturesMergeFieldsConstantsModule = angular.module('buildium.manager.leases.esignatures.constants.mergeFields', [])
    .constant('MERGE_FIELDS', MergeFields)
    .constant('MERGE_FIELD_SOURCE', MergeFieldSource)
    .constant('MERGE_FIELD_TYPES', MergeFieldTypes);

export const EsignaturesConstantsModule = angular.module('buildium.manager.leases.esignatures.constants', [
    HelloSignClientConstantsModule.name,
    EsignaturesStatusConstantsModule.name,
    EsignaturesSignerRolesConstantsModule.name,
    EsignaturesMergeFieldsConstantsModule.name,
    HelloSignSessionTimesConstantsModule.name
])
    .constant('REQUEST_ROLES_BY_ENTITY_TYPE', EntityTypeToRole)
    .constant('REQUEST_ENTITY_TYPE_BY_ROLE', RoleToEntityType)
    .constant('SIGNER_ROLE_DROPDOWN_OPTIONS', SignerRoleDropdownOptions)
    .constant('ENTITY_AND_ROLE_MAP', EntityAndRoleMap)
    .constant('MERGE_FIELD_STATUS', EsignaturesMergeFieldStatusEnum)
    .constant('DIRECTION', Direction)
    .constant('TEMPLATE_FILE_LIMIT', TemplateFileLimit)
    .constant('ESIGNATURE_REQUEST_FILE_LIMIT', EsignatureRequestFileLimit);
